module.exports = __webpack_public_path__ + "img/HZGB01-02.2f7c834.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/HZGB01-02.png
// module id = DgW2
// module chunks = 0